<template>
  <b-modal v-model="showModal" hide-footer>
    <template #modal-title>
      {{ service.name_th }}
    </template>
    <div v-if="service">
      <div class="pb-4">
        <img :src="service.picture" alt="" class="img-fluid rounded">
      </div>
      <div v-html="service.detail_th"></div>
      <div class="pt-2">
        <button class="btn btn-info btn-block" @click="showModal = false">ปิด</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    data () {
      return {
        showModal: false,
        service: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      }),
      ...mapState('chatBooking', ['bookingData'])
    },
    methods: {
      getService (services, id) {
        let service = null
        for (let key in services) {
          const item = services[key]
          if (item.id === id) {
            service = item
            break
          }
        }
        return service
      },
      openModal () {
        this.showModal = true
        const serviceId = Number(this.bookingData.service_id)
        this.service = this.getService(this.globalState.services, serviceId)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/ServiceDetailModal.vue